import type { JsonApiResponse } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

export interface ClientCaseAddendumReorderPatchOptions {
  newPosition: number;
}

export function clientCaseAddendumReorderApi(path: string) {
  return {
    path,
    PATCH: (params: ClientCaseAddendumReorderPatchOptions) =>
      api.patch<JsonApiResponse>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
